import * as React from 'react'
import {ReactElement} from 'react'
import { RadioGroup, RadioProps, Radio, Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../../styledComponents/Constants'
import {LeftColumnFlexContainer, LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {createErrorHandlingForm, ErrorHandlingFormProps} from '../hoc/createResidentErrorHandlingForm'
import {ErrorProps} from './ResidentHocInputErrorHandling'

export interface ResidentRadioButtonProps {
    label: string | ReactElement
    value: string
    description?: string
    radioProps?: RadioProps
}

interface Props {
    data: ResidentRadioButtonProps[]
    disabledDataList?: ResidentRadioButtonProps[]
    selectValue?: string
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
}

interface State {
    selectedValue: string
}

class PPRadioGroupForResident extends React.Component<Props & ErrorHandlingFormProps & ErrorProps, State> {

    constructor(props: Readonly<Props & ErrorHandlingFormProps & ErrorProps>) {
        super(props)
        this.state = {
            selectedValue: (props.selectValue) ? props.selectValue : ''
        }

        this.handleChange = this.handleChange.bind(this)
    }

    componentDidUpdate(prevProps: Props): void {
        if (prevProps.selectValue !== this.props.selectValue) {
            this.setState({
                selectedValue: (this.props.selectValue) ? this.props.selectValue : ''
            })
        }
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>, value: string): void {
        this.setState({
            selectedValue: value,
        })

        if (this.props.onChange) {
            this.props.onChange(event, value)
        }
    }


    render(): ReactElement {
        const {
            data, disabledDataList, selectValue, eventKeys, hasError, clearErrorMessage, eventEmitter, ...rest
        } = this.props

        return (
            <RadioGroup
                {...rest}
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                onChange={this.handleChange}
            >
                {
                    data.map((item, i) => {
                            const isDisabled =
                                disabledDataList?.some((list) => list.value === item.value)
                            return (
                                <Box mb={i !== data.length - 1 ? '10px' : undefined} key={i}>
                                    <RadioBackdrop
                                        selected={item.value === this.state.selectedValue} hasError={hasError}>
                                        <StyledDisabled disabled={isDisabled}>
                                            <LeftRowFlexContainer>
                                                <StyledRadio
                                                    value={item.value}
                                                    checked={item.value === this.state.selectedValue}
                                                    disabled={isDisabled}
                                                />
                                                <LeftColumnFlexContainer>
                                                    <RadioItem
                                                        descriptionAvailability={item.description}
                                                        disabled={isDisabled}>
                                                        {item.label}
                                                    </RadioItem>
                                                    {item.description && <Box>{item.description}</Box>}
                                                </LeftColumnFlexContainer>
                                            </LeftRowFlexContainer>
                                        </StyledDisabled>
                                    </RadioBackdrop>
                                </Box>
                            )
                        }
                    )
                }
            </RadioGroup>
        )
    }
}

export default createErrorHandlingForm(PPRadioGroupForResident)

const RadioBackdrop = styled.label<{ selected: boolean, hasError?: boolean }>`
  background-color: ${props => {
    if (props.hasError) {
        return 'rgb(253,245,246)'
    } else {
        if (props.selected) {
            return 'rgba(0, 112, 176, 0.15)'
        } else {
            return 'rgba(241, 241, 241, 1)'
        }
    }
}};
  ${props => props.hasError ? `outline: 1px solid rgb(215, 55, 74);` : ''}
    display: inline-block;
    cursor: pointer;
    width: 100%;
    padding: 13px 15px;
    box-sizing: border-box;
`

const StyledRadio = withStyles({
    root: {
        padding: 0,
        marginLeft: '-3px',
        marginRight: '10px',
        color: Colors.Body,
        '&$checked': {
            color: Colors.Primary,
        },
        '& .MuiSvgIcon-root': {
            fontSize: '22px',
        },
        '&$disabled': {
            color: '#BDBDBD',
        },
    },
    checked: {},
    disabled: {}
})
((props: RadioProps) => <Radio color="default" {...props} />)

const RadioItem = styled.div<{ descriptionAvailability?: string, disabled?: boolean }>`
  font-weight: ${props => {
    if (props.descriptionAvailability) {
        return FontWeights.Bold
    } else {
        return FontWeights.Normal
    }
}};
  ${props => props.disabled ? ''
    : props.descriptionAvailability ? `color:${Colors.AccentDark};`
        : ''}
`

const StyledDisabled = styled.div<{ disabled?: boolean }>`
  ${props => props.disabled ? `
    color: #BDBDBD;
    cursor: initial;
  ` : ''}
`
